module.exports = __webpack_public_path__ + "img/email.32da90b3.svg";